import { defineMessages } from 'react-intl';

const messages = defineMessages({
    bulkItemActionMenuAriaLabel: {
        defaultMessage: 'Bulk actions',
        description: 'Aria-label for the dropdown menu that shows actions for selected items',
        id: 'boxui.subHeader.bulkItemActionMenuAriaLabel',
    },
    metadata: {
        defaultMessage: 'Metadata',
        description: 'Text for metadata button that will open the metadata side panel',
        id: 'boxui.subHeader.metadata',
    },
});

export default messages;
